import { render, staticRenderFns } from "./EventMessage.vue?vue&type=template&id=3301f8bf&scoped=true&"
import script from "./EventMessage.vue?vue&type=script&lang=js&"
export * from "./EventMessage.vue?vue&type=script&lang=js&"
import style0 from "./EventMessage.vue?vue&type=style&index=0&id=3301f8bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3301f8bf",
  null
  
)

export default component.exports